import styles from './PostResult.module.scss';
import {useEffect} from "react";
import {useActions} from "../../hook/useActions";
import {useTypedSelector} from "../../hook/useTypedSelector";
import {useTranslation} from "react-i18next";
import {ArchProgress} from "../ProgressBarArchShaped";
import ArchText from "../ArchText";
import {ekadasi} from "../../constants/ekadasi-list";

const PostResult = () => {
    const {postResults} = useTypedSelector((store) => store.postPractice);
    const {t} = useTranslation();

    const {GetPostResults} = useActions();

    useEffect(() => {
        let country = localStorage.getItem("country") ?? "Ukraine";
        let city = localStorage.getItem("city") ?? "Rivne";
        GetPostResults(city, country);
    }, []);

    if (!postResults)
        return <></>;

    return (
        <>
            <div className={styles.cardContainer}>
                <div className={styles.cardMain}>
                    <div className={styles.cardMainText}>
                  <span>
                    <span className={styles.cardMainSubtitle}>
                      {t("PostPractice.PostResults.Title")}
                    </span>
                  </span>
                    </div>
                </div>

                <div className={styles.cardDate}>
                    <div
                        className={styles.cardDateText}>{new Intl.DateTimeFormat("uk-UA").format(new Date(postResults.date))}</div>
                </div>

                <div className={styles.cardType}>
                    <div
                        className={styles.cardTypeText}>{t("Ekadasi." + postResults.currentEkadashiName.replace(" Ekadasi", ""))}</div>
                </div>
            </div>


            <div className={styles.reportUa}>
                <img src="/images/post_results/bg2.png"/>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 10,
                    left: -10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "end",
                    alignItems: "flex-start"
                }}>
                    <ArchText text={t("PostPractice.PostResults.ProblemsLabel")} radius={80} startAngle={-45} endAngle={135} fontSize={18}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif'}} textColor={"#01609E"}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 10,
                    left: 10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "end",
                    alignItems: "flex-end"
                }}>
                    <ArchText text={t("PostPractice.PostResults.ProblemsLabel")} radius={80} startAngle={-135} endAngle={45} fontSize={18}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif'}} textColor={"#01609E"}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: -10,
                    left: 10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "flex-end"
                }}>
                    <ArchText text={t("PostPractice.PostResults.ProblemsLabel")} radius={80} startAngle={-225} endAngle={-45} fontSize={18}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif'}} textColor={"#01609E"}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: -10,
                    left: -10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "flex-start"
                }}>
                    <ArchText text={t("PostPractice.PostResults.ProblemsLabel")} radius={80} startAngle={-315} endAngle={-135} fontSize={18}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif'}} textColor={"#01609E"}></ArchText>
                </div>


                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <ArchText text={t("PostPractice.PostResults.Listeners")} radius={192} startAngle={-42}
                              endAngle={138} fontSize={22} textAnchor={"end"}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif', fontWeight: 600, letterSpacing: 1}}
                              textColor={"#03578B"} inner={true}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <ArchText text={t("PostPractice.PostResults.Patrons")} radius={192} startAngle={-47}
                              endAngle={133} fontSize={22} textAnchor={"start"}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif', fontWeight: 600, letterSpacing: 1}}
                              textColor={"#FA2E2E"} inner={true}></ArchText>
                </div>

                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <ArchText text={t("PostPractice.PostResults.Trainees")} radius={192} startAngle={-135} endAngle={45}
                              fontSize={22}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif', fontWeight: 600, letterSpacing: 1}}
                              textColor={"#AB5600"} inner={true}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <ArchText text={t("PostPractice.PostResults.Curators")} radius={170} startAngle={-225}
                              endAngle={-45} fontSize={22}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif', fontWeight: 600, letterSpacing: 1}}
                              textColor={"#9B3502"} inner={false}></ArchText>
                </div>
                <div style={{
                    position: "absolute",
                    width: "480px",
                    height: "480px",
                    top: 0,
                    left: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <ArchText text={t("PostPractice.PostResults.Mentors")} radius={170} startAngle={-315}
                              endAngle={-135} fontSize={22}
                              fontStyle={{fontFamily: '"Advent Pro", sans-serif', fontWeight: 600, letterSpacing: 1}}
                              textColor={"#998302"} inner={false}></ArchText>
                </div>


                <div
                    className={styles.num01}>{(postResults.problems.spiritual < 10 ? "0" : "") + postResults.problems.spiritual}</div>
                <div
                    className={styles.num02}>{(postResults.problems.psychological < 10 ? "0" : "") + postResults.problems.psychological}</div>
                <div
                    className={styles.num03}>{(postResults.problems.health < 10 ? "0" : "") + postResults.problems.health}</div>
                <div
                    className={styles.num04}>{(postResults.problems.spirits < 10 ? "0" : "") + postResults.problems.spirits}</div>
                <div
                    className={styles.num05}>{(postResults.problems.relationships < 10 ? "0" : "") + postResults.problems.relationships}</div>
                <div
                    className={styles.num06}>{(postResults.problems.financial < 10 ? "0" : "") + postResults.problems.financial}</div>
                <div
                    className={styles.num07}>{(postResults.problems.addiction < 10 ? "0" : "") + postResults.problems.addiction}</div>
                <div
                    className={styles.num08}>{(postResults.problems.others < 10 ? "0" : "") + postResults.problems.others}</div>
                <div
                    className={styles.num09}>{(postResults.problems.officials < 10 ? "0" : "") + postResults.problems.officials}</div>
                <div
                    className={styles.num10}>{(postResults.problems.law < 10 ? "0" : "") + postResults.problems.law}</div>
                <div
                    className={styles.num11}>{(postResults.problems.deadInDreams < 10 ? "0" : "") + postResults.problems.deadInDreams}</div>
                <div
                    className={styles.num12}>{(postResults.problems.society < 10 ? "0" : "") + postResults.problems.society}</div>

                <div className={styles.arcProgress}>
                    <ArchProgress
                        progress={postResults.myPercentages}
                        size={240}
                        strokeWidth={20}
                        startAngle={30}
                        endAngle={330}
                        color="#0092CB"
                        textColor="#237EB8"
                        text={postResults.myPercentages.toString() + "%"}
                    />
                </div>

                <div className={styles.arcProgress}>
                    <ArchProgress
                        progress={(postResults.totalPercentages / postResults.participantsCount)}
                        size={330}
                        strokeWidth={30}
                        startAngle={30}
                        endAngle={330}
                        fontSize={18}
                        color="#FFD505"
                        textColor="#955B37"
                        text={postResults.totalPercentages.toString() + "%"}
                    />
                </div>

                <div className={styles.arcProgress}>
                    <div style={{position: "relative", height: "172px", width: "172px"}}>
                        <svg style={{position: "absolute", bottom: 0}} width="172" height="137" viewBox="0 0 172 137"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="path-1-inside-1_3225_13897" fill="white">
                                <path
                                    d="M154.578 2.28882e-05C163.842 12.6483 169.452 27.5988 170.796 43.219C172.14 58.8391 169.166 74.5283 162.199 88.573C155.232 102.618 144.54 114.478 131.29 122.859C118.04 131.24 102.742 135.818 87.0667 136.095C71.3913 136.372 55.9411 132.337 42.4035 124.429C28.8659 116.522 17.7614 105.046 10.3026 91.2563C2.84388 77.4664 -0.682334 61.8921 0.109095 46.2342C0.900524 30.5763 5.97916 15.437 14.7904 2.46941L85.5556 50.5531L154.578 2.28882e-05Z"/>
                            </mask>
                            <path
                                d="M154.578 2.28882e-05C163.842 12.6483 169.452 27.5988 170.796 43.219C172.14 58.8391 169.166 74.5283 162.199 88.573C155.232 102.618 144.54 114.478 131.29 122.859C118.04 131.24 102.742 135.818 87.0667 136.095C71.3913 136.372 55.9411 132.337 42.4035 124.429C28.8659 116.522 17.7614 105.046 10.3026 91.2563C2.84388 77.4664 -0.682334 61.8921 0.109095 46.2342C0.900524 30.5763 5.97916 15.437 14.7904 2.46941L85.5556 50.5531L154.578 2.28882e-05Z"
                                fill="#FF8383" stroke="#80303F" stroke-width="2"
                                mask="url(#path-1-inside-1_3225_13897)"/>
                        </svg>
                    </div>
                </div>

                <div className={styles.progressBarDesc}>
                    <div>{t("PostPractice.PostResults.Progress.Received")}</div>
                    <div style={{marginTop: 18}}>{t("PostPractice.PostResults.Progress.Given")}</div>
                    <div style={{marginTop: 14}}>{t("PostPractice.PostResults.Progress.Results")}</div>
                    <div>{t("PostPractice.PostResults.Progress.Stronger")}</div>
                    <div>{t("PostPractice.PostResults.Progress.Times")}</div>
                    <div
                        style={{marginTop: 50}}>{postResults.myPercentages > 0 ? Math.round(postResults.totalPercentages / postResults.myPercentages) : 0}</div>
                </div>
            </div>

            <div className={styles.reportHistoryLabel}>{t("PostPractice.PostResults.History.Title")}</div>
            <table className={styles.reportHistory}>
                <thead>
                <tr>
                    <th className={styles.eName}>{t("PostPractice.PostResults.History.Name")}</th>
                    <th>{t("PostPractice.PostResults.History.PCount")}</th>
                    <th>{t("PostPractice.PostResults.History.ForOther")}</th>
                    <th>{t("PostPractice.PostResults.History.Blessing")}</th>
                    <th>{t("PostPractice.PostResults.History.ResultsMultiplier")}</th>
                </tr>
                </thead>
                <tbody>
                {postResults.ekadashiHistory.map((eh: any, index: number) => (
                    <tr key={index}>
                        <td className={styles.eNameCell}>{`${(ekadasi.findIndex((e: string) => e === eh.name.replace(" Ekadasi", "")) + 1).toString().padStart(2, '0')}-${t("Ekadasi." + eh.name.replace(" Ekadasi", ""))}`}</td>
                        <td>{eh.participantCount}</td>
                        <td>{eh.forEveryone}</td>
                        <td>{eh.blessing}</td>
                        <td>{eh.forEveryone > 0 ? Math.round(eh.blessing / eh.forEveryone) : 0}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    );
}

export default PostResult;
